// extracted by mini-css-extract-plugin
module.exports = {"recentTime":"recentTime_recentTime__2MKjs","recentModal":"recentTime_recentModal__1x0YR","content":"recentTime_content__3cp1u"};